module.exports = __webpack_public_path__ + "static/media/r288.c419161b.jpg";